// src/components/home/InkFlourish.jsx
import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useInView } from "./motion";

// CSS/SVG only, no WebGL — kept outside useCapability's gating entirely so
// even the fallback path gets a closing beat. See
// docs/superpowers/specs/2026-08-25-home-threejs-synergy-design.md §4 Beat 5, §7.
export default function InkFlourish() {
  const theme = useTheme();
  const { ref, visible } = useInView({ threshold: 0.4 });
  return (
    <Box ref={ref} sx={{ display: "flex", justifyContent: "center", mt: 1.5 }}>
      <svg width="180" height="20" viewBox="0 0 180 20" fill="none" aria-hidden="true">
        <path
          d="M4 12 Q 45 2, 90 12 T 176 10"
          stroke={theme.home.coral}
          strokeWidth="3"
          strokeLinecap="round"
          pathLength={1}
          style={{
            strokeDasharray: 1,
            strokeDashoffset: visible ? 0 : 1,
            transition: "stroke-dashoffset 0.9s cubic-bezier(0.22,1,0.36,1) 0.2s",
          }}
        />
      </svg>
    </Box>
  );
}
